import { useSEO } from '../useSEO';

const testimonials = [
  '"Working with Ivy was a total game-changer for our family. Before, our mornings were pure chaos and the playroom was a \'no-go\' zone."\n\nThey didn\'t just tidy up; they built a Household Management system that actually works for us. Now, the kids know exactly where their gear goes, and my daily to-do list feels manageable for the first time in years. It feels like our home finally has room to breathe again!',
  '"I used to spend my entire weekend playing catch-up with the house, but Ivy completely flipped the script. They didn\'t just organise our cupboards; they restructured how our entire household functions.\n\nFrom streamlining our laundry routine to setting up a system for domestic duties that everyone can follow, the \'mental load\' is finally gone. I\'ve gone from feeling like a constant manager of chaos to actually enjoying my home again. Truly the best investment I\'ve made for my sanity!"',
];

function TestimonialsPage() {
  useSEO({
    title: 'Client Testimonials | Reset & Run',
    description: 'Read what clients say about working with Ivy from Reset & Run — real stories of homes transformed and families finding calm.',
    path: '/testimonials',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Client Testimonials | Reset & Run',
      url: 'https://www.resetandrun.com.au/testimonials',
      description: 'Read what clients say about working with Ivy from Reset & Run — real stories of homes transformed and families finding calm.',
    },
  });
  return (
    <main className="subpage">
      <section className="testimonials testimonials--page">
        <div className="section-heading">
          <h3>What Clients are Saying</h3>
        </div>
        <div className="testimonial-grid">
          {testimonials.map((quote) => (
            <blockquote className="testimonial-card" key={quote}>
              <p>{quote}</p>
            </blockquote>
          ))}
        </div>
      </section>
    </main>
  );
}

export default TestimonialsPage;
